export const ROLE_SUPER_ADMIN = 'super_admin';
export const ROLE_AUDITOR = 'auditor';
export const ROLE_FINANCE = 'finance';
// 运营专员：配置类页面（分类/Banner/积分规则等），无审核权
export const ROLE_OPERATOR = 'operator';
// 仲裁委员：争议退款审批、终止合作审批（P1 场景，先定义角色）
export const ROLE_ARBITER = 'arbiter';
// 视频上传专员：仅视频上传菜单（内容生产岗，无审核权）
export const ROLE_VIDEO_UPLOADER = 'video_uploader';
// 内容审核员：内容审核中心 + 三个管理页只读（无发布/删除权）
export const ROLE_CONTENT_AUDITOR = 'content_auditor';

export const USER_STATUS = {
  NORMAL: 'normal',
  DISABLED: 'disabled',
};

export const AUDIT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const HOSPITAL_TYPE = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};

export const ORDER_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PAID: 'paid',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
};

export const RISK_LEVEL = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

export const RISK_ACTION = {
  BLOCK: 'block',
  REPORT: 'report',
};

export const RISK_MOUNT_POINT = {
  USER_CHAT: 'user_chat',
  HOSPITAL_RECOMMEND: 'hospital_recommend',
  AFTERCARE_VISIT: 'aftercare_visit',
};

export const ALERT_STATUS = {
  PENDING: 'pending',
  HANDLED: 'handled',
};

export const MENU_CONFIG = {
  DASHBOARD: 'dashboard',
  AUDIT_CENTER: 'audit_center',
  CUSTOMER: 'customer',
  SERVICE: 'service',
  CHANNEL: 'channel',
  KNOWLEDGE: 'knowledge',
  SETTLEMENT: 'settlement',
  JOIN: 'join',
  LIFE: 'life',
  SYSTEM: 'system',
};

export const PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];
